import React from 'react';

import { useTranslate } from 'gatsby-theme-soluble-source';

import { graphql } from 'gatsby';

import {
    default as GlossarySectionDS,
    GlossarySectionProps,
} from 'design-system/src/components/organisms/GlossarySection';

interface GlossarySectionCMSProps {
    letters: GlossarySectionProps['letters'];
}

export default function GlossarySection({ letters }: GlossarySectionCMSProps) {
    const _ = useTranslate();

    return (
        <GlossarySectionDS
            letters={letters}
            showMoreLabel={_['glossary.showMore.label']?.text}
        />
    );
}

export const query = graphql`
    fragment DatoCmsGlossaryLetter on DatoCmsGlossaryLetter {
        letter
        items {
            ...DatoCmsGlossaryTermLinkItem
        }
    }
    fragment DatoCmsGlossarySection on DatoCmsGlossarySection {
        letters {
            ...DatoCmsGlossaryLetter
        }
    }
`;
